import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectskalpataru } from "../../../../data/projects/kalpataru/data";

export const Vivant = () => {
  const {
    kalpataruvivant: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectskalpataru;

  return (
    <>
      <Helmet>
        <title>Kalpataru Vivant Andheri East, Mumbai – Luxury 2 & 3 BHK Apartments</title>

        <meta
          name="description"
          content="Explore Kalpataru Vivant in Andheri East, Mumbai – a premium residential project offering spacious 2 & 3 BHK apartments with world-class amenities. Book your dream home today!"
        />

        <meta
          name="keywords"
          content="Kalpataru Vivant, Kalpataru Vivant Andheri East, Kalpataru Vivant Mumbai, Kalpataru Andheri East, luxury apartments in Andheri East, 2 BHK in Andheri East, 3 BHK in Andheri East, Kalpataru Vivant price, Kalpataru Vivant amenities"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/kalpataru-vivant-andheri-east-mumbai"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
